/* eslint-disable max-lines-per-function */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SpringBigStoreProvider: ()=>SpringBigStoreProvider,
    useSpringBigStore: ()=>useSpringBigStore
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _usehooksTs = require("usehooks-ts");
const _ = require("..");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const SpringBigStoreContext = /*#__PURE__*/ _react.default.createContext({});
const SpringBigStoreProvider = ({ children , queryClient  })=>{
    const [memberAccessCodeId, setMemberAccessCodeId] = (0, _react.useState)();
    const [paramId, setParamId] = (0, _react.useState)();
    const [member, setMember] = (0, _react.useState)();
    const [birthdays, setBirthdays] = (0, _react.useState)(null);
    const [birthdayInput, setBirthdayInput] = (0, _react.useState)('four_choice');
    const [nextStep, setNextStep] = (0, _react.useState)(null);
    const [didFetchSettings, setFetchSettings] = (0, _react.useState)(false);
    const [didCheckDemoMode, setCheckDemoMode] = (0, _react.useState)(false);
    const [didSetEnvUrl, setDidSetEnvUrl] = (0, _react.useState)(false);
    const [merchant, setMerchant] = (0, _react.useState)();
    const [giftCards, setGiftCards] = (0, _react.useState)([]);
    const [giftCardPresetAmounts, setGiftCardPresetAmounts] = (0, _react.useState)([
        20,
        30,
        40,
        50,
        60
    ]);
    const [giftCardPaymentList, setGiftCardPaymentList] = (0, _react.useState)([]);
    const [stashboards, setStashboards] = (0, _react.useState)([]);
    const [stashboardTarget, setStashboardTarget] = (0, _react.useState)(null);
    const [stashboardKeys, setStashboardKeys] = (0, _react.useState)(null);
    const [receivedGiftCard, setReceivedGiftCard] = (0, _react.useState)(false);
    const [merchantName, setMerchantName] = (0, _react.useState)('');
    const [tendlcLogoSrc, setTendlcLogoSrc] = (0, _react.useState)(undefined);
    const [showAnimatedLoader, setShowAnimatedLoader] = (0, _react.useState)(false);
    const [isMessagesNofticationLoading, setIsMessagesNofticationLoading] = (0, _react.useState)(false);
    const { setValue: setState , value: state , removeValue: removeState  } = (0, _.useStorageValue)('state');
    const { setValue: setPhoneNumber , value: phoneNumber , removeValue: removePhoneNumber  } = (0, _.useStorageValue)('phoneNumber');
    const { setValue: setMobileSubscriberId , value: mobileSubscriberId , removeValue: removeMobileSubscriberId  } = (0, _.useStorageValue)('mobileSubscriberId');
    const { setValue: setWalletId , value: walletId , removeValue: removeWalletId  } = (0, _.useStorageValue)('walletId');
    const { setValue: setApiEnv , value: apiEnv  } = (0, _.useStorageValue)('apiEnv');
    const { setValue: setQAMerchant , value: qaMerchant  } = (0, _.useStorageValue)('qaMerchant');
    const { setValue: setMerchantId , value: merchantId , removeValue: removeMerchantId  } = (0, _.useStorageValue)('merchantId');
    const { setValue: setFirebaseToken , value: firebaseToken  } = (0, _.useStorageValue)('firebaseToken');
    const { setValue: setDemoMode , value: demoMode  } = (0, _.useStorageValue)('demoMode');
    const { setValue: setColorMode , value: colorMode  } = (0, _.useStorageValue)('colorMode');
    const { setValue: setMemberId , value: memberId  } = (0, _.useStorageValue)('memberId');
    const { setValue: setMerchantOrg , value: merchantOrgOverride  } = (0, _.useStorageValue)('merchantOrg');
    const { setValue: setFullLogo , value: fullLogo  } = (0, _.useStorageValue)('fullLogo');
    const { setValue: setNavLogo , value: navLogo  } = (0, _.useStorageValue)('navLogo');
    const { setValue: setLightBackground , value: lightBackground  } = (0, _.useStorageValue)('lightBackground');
    const { setValue: setDarkBackground , value: darkBackground  } = (0, _.useStorageValue)('darkBackground');
    const { setValue: setTheme , value: theme  } = (0, _.useStorageValue)('theme');
    const { setValue: setLastNameCheckDate , value: lastNameCheckDate , removeValue: removeLastNameCheckDate  } = (0, _.useStorageValue)('lastNameCheckDate');
    const performAppSettingsFetch = (0, _react.useCallback)(async ()=>{
        await _.api.demoFetch.fetchDemoResponses();
        await (0, _.fetchAppSettings)();
        setFetchSettings(true);
    }, []);
    const cleanState = (0, _react.useCallback)(async ()=>{
        await removePhoneNumber();
        await removeMobileSubscriberId();
        await removeWalletId();
        await removeMerchantId();
        await removeState();
        await removeLastNameCheckDate();
        setMember(null);
        setBirthdays(null);
        setNextStep(null);
        setMemberId(null);
        setMerchant(null);
    }, [
        removePhoneNumber,
        removeMobileSubscriberId,
        removeWalletId,
        removeMerchantId,
        removeState
    ]);
    const logout = (0, _react.useCallback)(async ()=>{
        await removeState();
        await removeMerchantId();
        await removeMobileSubscriberId();
        await removePhoneNumber();
        await removeWalletId();
    }, [
        removeMerchantId,
        removeMobileSubscriberId,
        removePhoneNumber,
        removeWalletId,
        removeState
    ]);
    const changeMerchantOrg = (0, _react.useCallback)(async (newOrg)=>{
        await setMerchantOrg(newOrg);
        await logout();
    }, []);
    const hasFeature = (0, _react.useCallback)((identifier)=>{
        return merchant?.features?.some((feature)=>feature.identifier === identifier) ?? false;
    }, [
        merchant
    ]);
    const switchApiEnv = (0, _react.useCallback)(async (env)=>{
        (0, _.changeApiUrl)(env);
        await setApiEnv(env);
        await cleanState();
        _.observer.emit('env-changed', {
            env: env
        });
    }, [
        setApiEnv,
        cleanState
    ]);
    const goHome = (0, _react.useCallback)(()=>{
        removeMerchantId();
    }, [
        removeMerchantId
    ]);
    const assertDemoMode = (0, _react.useCallback)(async ()=>{
        // This should only ever run once, on app load.
        if (didCheckDemoMode) {
            return;
        }
        if (!demoMode) {
            await setDemoMode(false);
        }
        if (demoMode === true) {
            await setDemoMode(false);
            _.observer.emit('demo-cleared');
        }
        setCheckDemoMode(true);
    }, [
        didCheckDemoMode,
        demoMode,
        cleanState,
        setDemoMode,
        setCheckDemoMode
    ]);
    (0, _usehooksTs.useEffectOnce)(()=>{
        performAppSettingsFetch();
    });
    (0, _react.useEffect)(()=>{
        if (apiEnv) {
            (0, _.changeApiUrl)(apiEnv);
            setDidSetEnvUrl(true);
        }
        if (apiEnv === null) {
            switchApiEnv(__DEV__ ? _.defaultDevEnv : 'production');
        }
        if (colorMode === null) {
            setColorMode('light');
        }
    }, [
        apiEnv,
        switchApiEnv,
        colorMode,
        setColorMode
    ]);
    (0, _.useOnceAppEvent)('demo-cleared', async ()=>{
        await cleanState();
    }, [
        cleanState
    ]);
    (0, _react.useEffect)(()=>{
        assertDemoMode();
    }, [
        assertDemoMode
    ]);
    (0, _react.useEffect)(()=>{
        _.api.setStore({
            phoneNumber,
            mobileSubscriberId
        });
    }, [
        phoneNumber,
        mobileSubscriberId
    ]);
    const isPreparingData = (0, _react.useMemo)(()=>apiEnv === undefined || colorMode === undefined || didSetEnvUrl === false || didFetchSettings === false || mobileSubscriberId === undefined || phoneNumber === undefined || walletId === undefined || memberId === undefined, [
        apiEnv,
        colorMode,
        didSetEnvUrl,
        didFetchSettings,
        mobileSubscriberId,
        phoneNumber,
        walletId,
        memberId
    ]);
    (0, _react.useEffect)(()=>{
        if (isPreparingData || apiEnv === null) {
            return;
        }
        _.observer.emit('app-started');
    }, [
        isPreparingData,
        apiEnv
    ]);
    return /*#__PURE__*/ _react.default.createElement(SpringBigStoreContext.Provider, {
        value: {
            isPreparingData,
            apiEnv,
            switchApiEnv,
            merchantId,
            setMerchantId,
            hasFeature,
            phoneNumber,
            setPhoneNumber,
            memberAccessCodeId,
            setMemberAccessCodeId,
            mobileSubscriberId,
            setMobileSubscriberId,
            walletId,
            setWalletId,
            paramId,
            setParamId,
            member,
            setMember,
            memberId,
            birthdays,
            setBirthdays,
            birthdayInput,
            setBirthdayInput,
            nextStep,
            setNextStep,
            setMemberId,
            merchantOrgOverride,
            changeMerchantOrg,
            stashboardKeys: stashboardKeys || [],
            setStashboardKeys,
            stashboards: stashboards || [],
            setStashboards,
            stashboardTarget,
            setStashboardTarget,
            firebaseToken,
            setFirebaseToken,
            goHome,
            setDemoMode,
            cleanState,
            setColorMode,
            colorMode,
            demoMode,
            setState,
            state,
            logout,
            removeMerchantId,
            merchant,
            setMerchant,
            setApiEnv,
            giftCardPresetAmounts,
            setGiftCardPresetAmounts,
            giftCards,
            setGiftCards,
            receivedGiftCard,
            setReceivedGiftCard,
            giftCardPaymentList,
            setGiftCardPaymentList,
            navLogo,
            setNavLogo,
            fullLogo,
            setFullLogo,
            darkBackground,
            setDarkBackground,
            lightBackground,
            setLightBackground,
            theme,
            setTheme,
            setQAMerchant,
            qaMerchant,
            lastNameCheckDate,
            setLastNameCheckDate,
            merchantName,
            setMerchantName,
            tendlcLogoSrc,
            setTendlcLogoSrc,
            showAnimatedLoader,
            setShowAnimatedLoader,
            isMessagesNofticationLoading,
            setIsMessagesNofticationLoading
        }
    }, children);
};
const useSpringBigStore = ()=>_react.default.useContext(SpringBigStoreContext);
